import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "my-feature-flag-called-events-show-none-or-false-instead-of-my-variant-names"
    }}>{`My `}<inlineCode parentName="h2">{`Feature Flag Called`}</inlineCode>{` events show `}<inlineCode parentName="h2">{`None`}</inlineCode>{` or `}<inlineCode parentName="h2">{`false`}</inlineCode>{` instead of my variant names`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`Feature Flag Response`}</inlineCode>{` property is `}<inlineCode parentName="p">{`false`}</inlineCode>{` for users who called your feature flag but did not match any of the rollout conditions.`}</p>
    <p><inlineCode parentName="p">{`None`}</inlineCode>{` indicates that feature flag is disabled or failed to load. For example, due to network error or something unexpected.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      